import { LayersIcon, ShieldCheckIcon, SlidersHorizontalIcon } from "lucide-react";
import type { SkillCategory } from "~/pages/skills/skills.types";

interface SkillsSummaryProps {
  categories: SkillCategory[];
}

export function SkillsSummary({ categories }: Readonly<SkillsSummaryProps>) {
  const totalSkills = categories.reduce((s, c) => s + c.skills.length, 0);
  const systems = new Set(categories.flatMap((c) => c.skills.map((s) => s.ratingSystem)));

  return (
    <div className="flex flex-wrap gap-4">
      <div className="flex items-center gap-2.5 rounded-lg border border-border bg-card px-4 py-3">
        <div className="flex size-8 items-center justify-center rounded-lg bg-abyss-50 dark:bg-abyss-900">
          <LayersIcon className="size-4 text-abyss-500" />
        </div>
        <div>
          <p className="font-heading text-xl font-bold tabular-nums leading-none">{categories.length}</p>
          <p className="text-xs text-muted-foreground">categories</p>
        </div>
      </div>
      <div className="flex items-center gap-2.5 rounded-lg border border-border bg-card px-4 py-3">
        <div className="flex size-8 items-center justify-center rounded-lg bg-shallow-50 dark:bg-shallow-900">
          <ShieldCheckIcon className="size-4 text-shallow-600" />
        </div>
        <div>
          <p className="font-heading text-xl font-bold tabular-nums leading-none">{totalSkills}</p>
          <p className="text-xs text-muted-foreground">skills defined</p>
        </div>
      </div>
      <div className="flex items-center gap-2.5 rounded-lg border border-border bg-card px-4 py-3">
        <div className="flex size-8 items-center justify-center rounded-lg bg-violet-50 dark:bg-violet-900">
          <SlidersHorizontalIcon className="size-4 text-violet-500" />
        </div>
        <div>
          <p className="font-heading text-xl font-bold tabular-nums leading-none">{systems.size}</p>
          <p className="text-xs text-muted-foreground">rating systems</p>
        </div>
      </div>
    </div>
  );
}
